import React from 'react'
import { Link } from 'react-router-dom'

export const JoinButton = ({ hasPlayback, sessionId }) => {
  return (
    <div className="cardAction align-self-end text-center">
      {hasPlayback ?
        <Link to={`auditorium-hall/${sessionId}?playback`} className="join-button">
          <span>Watch Replay</span>
        </Link>
        :
        <></>
      }
    </div>
  )
}